import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { take } from 'rxjs';

import { TicketsService } from '@app/services/tickets.service';
import { filterNullish$ } from '@shared/utils/rxjs/filter-nullish.rxjs.util';

@Component({
  selector: 'app-bulk-ticket-type-message',
  templateUrl: './bulk-ticket-type-message.component.html',
  styleUrls: ['./bulk-ticket-type-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkTicketTypeMessageComponent {
  @Input() pmsType: number;
  @Input() declare categoryId: number;
  @Input() topicId: number;
  @Input() declare origin: string;

  ticketsService = inject(TicketsService);

  categories$ = this.ticketsService.getCategories().pipe(filterNullish$(), take(1));
}
